import { openAiProjectFile } from './aiProjectStore'
import { saveAiProjectDb, clearCurrentProjectId } from './aiProjectDb'

// Curated "Get started" example projects, hosted as public .plodeai bundles on
// GCS with a small index.json manifest. Direct public fetch (no backend). Each
// bundle is the SAME format the app exports, so opening one is a normal import.
//
// Layout in the bucket:
//   ai_example_projects/index.json                 -> [{ slug, name, description,
//                                                       videoLink, thumbnail, bundle }]
//   ai_example_projects/<slug>/project.plodeai
const RAW_BASE =
    process.env.REACT_APP_EXAMPLES_BASE ||
    'https://storage.googleapis.com/plode_web'
const BASE = `${RAW_BASE.replace(/\/+$/, '')}/ai_example_projects`

// Resolve a manifest url (thumbnail/bundle) that may be absolute or relative.
const absUrl = (u) =>
    !u
        ? ''
        : /^https?:\/\//i.test(u)
        ? u
        : `${BASE}/${String(u).replace(/^\/+/, '')}`

export const listExampleProjects = async () => {
    const res = await fetch(`${BASE}/index.json`, { cache: 'no-cache' })
    if (!res.ok) throw new Error('Could not load example projects')
    const list = await res.json()
    return (Array.isArray(list) ? list : [])
        .filter((e) => e && e.bundle)
        .map((e) => ({
            slug: e.slug || e.name || '',
            name: e.name || 'Example project',
            description: e.description || '',
            videoLink: e.videoLink || '',
            thumbnail: absUrl(e.thumbnail),
            bundle: absUrl(e.bundle),
        }))
}

// Fetch an example bundle, import it into the live studio, then save a FRESH
// copy into "Your Projects" (with the example's metadata) so the user edits
// their own copy — the example itself stays untouched.
export const openExampleProject = async (example) => {
    const res = await fetch(example.bundle, { cache: 'no-cache' })
    if (!res.ok) throw new Error('Could not load this example')
    const blob = await res.blob()
    await openAiProjectFile(blob) // restores session + IndexedDB into the studio
    // Drop the current-project pointer so this saves as a NEW project rather than
    // overwriting whatever was previously open.
    clearCurrentProjectId()
    return saveAiProjectDb({
        name: example.name,
        description: example.description,
        videoLink: example.videoLink,
        images: example.thumbnail ? [example.thumbnail] : [],
    })
}
